<template>
  <div class="container">
    <div class="list-category-card" v-for="item in couponCategoryList">
      <i
        class="el-icon-error activeDelBtn"
        @click.stop="removeCouponCategory(item)"
      ></i>
      <p>{{ item.categoryName }}</p>
    </div>
    <el-card
      class="add-btn"
      shadow="never"
      body-style="padding: 0"
      @click.native="addHandler"
    >
      <i class="el-icon-plus"></i>
    </el-card>

    <el-dialog
      title="添加商品"
      :visible.sync="dialogVisible"
      width="30%"
      :before-close="handleClose"
      v-loading="dialogLoading"
    >
      <el-select
        v-model="categoryData"
        multiple
        filterable
        remote
        reserve-keyword
        placeholder="请输入品类名称"
        :remote-method="searchCategory"
        :loading="categoryLoading"
        style="width: 100%"
      >
        <el-option
          v-for="item in categoryList"
          :key="item.categoryId"
          :label="item.categoryName"
          :value="item.categoryId"
        >
        </el-option>
      </el-select>

      <el-button
        type="primary"
        style="margin-top: 20px;"
        @click="addNewCouponCategory"
        >保存</el-button
      >
    </el-dialog>
  </div>
</template>
<script>
import inputTag from "./inputTag";
import {
  getCouponCategoryApi,
  saveCouponCategoryApi,
  delCouponCategoryApi
} from "@/api/coupon";
import { selectCategoryPost } from "@/api/api";
export default {
  name: "couponCategory",
  components: { inputTag },
  props: {
    couponId: {
      required: true,
      type: Number | String
    }
  },
  data() {
    return {
      dialogVisible: false,
      dialogLoading: false,
      categoryLoading: false,
      couponCategoryList: [],
      categoryList: [],
      categoryData: []
    };
  },
  watch: {
    couponId: function(v) {
      if (v) {
        this.loadCouponCategory();
      } else {
        this.couponCategoryList = [];
      }
    }
  },
  created() {},
  methods: {
    addHandler() {
      if (!this.couponId) {
        this.$message({
          message: "请先保存基础信息后在添加",
          type: "warning"
        });
        return;
      }
      this.dialogVisible = true;
    },
    loadCouponCategory() {
      let _self = this;
      if (this.couponId) {
        getCouponCategoryApi(this.couponId).then(res => {
          if (res.data.status == 100) {
            _self.couponCategoryList = res.data.results;
          }
        });
      }
    },
    searchCategory(query) {
      if (query !== "") {
        console.log(query);
        this.categoryLoading = true;
        selectCategoryPost({ categoryName: query })
          .then(res => {
            if (res.data.status == 100) {
              this.categoryList = res.data.results;
            } else {
              this.$message({ message: res.data.message, type: "warning" });
            }
          })
          .finally(() => {
            this.categoryLoading = false;
          });
      }
    },
    handleClose() {
      this.dialogVisible = false;
      this.categoryData = [];
    },
    addNewCouponCategory() {
      if (this.categoryData && this.categoryData.length > 0) {
        this.saveCouponCategory();
      } else {
        this.$message({ message: "请确认需要添加的型号", type: "warning" });
      }
    },
    saveCouponCategory() {
      let _self = this;
      if (this.categoryData && this.categoryData.length > 0 && this.couponId) {
        _self.dialogLoading = true;
        saveCouponCategoryApi(this.couponId, this.categoryData)
          .then(res => {
            if (res.data.status == 100) {
              _self.loadCouponCategory();
              _self.handleClose();
            } else {
              this.$message({ message: res.data.message, type: "warning" });
            }
          })
          .finally(() => {
            _self.dialogLoading = false;
          });
      }
    },
    removeCouponCategory(item) {
      let _self = this;
      if (item && item.id) {
        this.$confirm(`是否删除当前型号${item.categoryName}`, "提示", {
          type: "warning"
        })
          .then(() => {
            delCouponCategoryApi(item.id).then(res => {
              if (res.data.status == 100) {
                _self.loadCouponCategory();
                _self.handleClose();
              } else {
                this.$message({ message: res.data.message, type: "warning" });
              }
            });
          })
          .catch(() => {});
      }
    }
  }
};
</script>
<style lang="scss" type="text/css" scoped>
.container {
  padding-top: 20px;
  display: flex;
  align-items: center;
  flex-flow: row wrap;
}
.list-category-card {
  align-items: center;
  justify-content: center;
  display: flex;

  position: relative;
  width: 200px;
  height: 80px;
  margin: 0 20px;
  margin-top: 10px;
  border: 1px solid #c6c6c6;
  border-radius: 20px;
  padding: 10px;
  .activeDelBtn {
    display: none;
    position: absolute;
    top: 5px;
    left: 5px;
    color: #c41335;
  }
  &:hover .activeDelBtn {
    display: block;
  }
}
.add-btn {
  width: 50px;
  height: 50px;
  border: 1px dashed #c6c6c6;
  line-height: 50px;
  display: flex;
  justify-content: center;
  i {
    font-size: 20px;
  }
}
</style>



// WEBPACK FOOTER //
// couponCategory.vue?4ef8d2f0